export type FeedAliasIndex = Map<string, Set<string>>

export const addFeedAliasMapping = (args: {
  aliasIndex: FeedAliasIndex
  aliasWeekKey: string
  primaryKey: string
}): void => {
  const existing = args.aliasIndex.get(args.aliasWeekKey)
  if (existing) {
    existing.add(args.primaryKey)
    return
  }

  args.aliasIndex.set(args.aliasWeekKey, new Set([args.primaryKey]))
}

export const resolveFeedPrimaryKeyForWaterRow = (args: {
  tokenCandidates: string[]
  week: string
  aliasIndex: FeedAliasIndex
  hasPrimaryKey: (candidate: string) => boolean
}): string | null => {
  for (const token of args.tokenCandidates) {
    const aliasWeekKey = `${token}-${args.week}`
    const mappedCandidates = args.aliasIndex.get(aliasWeekKey)

    if (mappedCandidates && mappedCandidates.size === 1) {
      const [mappedPrimary] = Array.from(mappedCandidates)
      if (mappedPrimary && args.hasPrimaryKey(mappedPrimary)) {
        return mappedPrimary
      }
    }

    if (!mappedCandidates || mappedCandidates.size === 0) {
      const directKey = `${token}-${args.week}`
      if (args.hasPrimaryKey(directKey)) {
        return directKey
      }
    }
  }

  return null
}
